import "../assets/styles/styles.css";
import "../assets/styles/bootstrap.min.css";
import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { ethers } from "ethers";
import axios from "axios";
import MDEditor from "@uiw/react-md-editor";
import { Form, Button, Modal } from "react-bootstrap";
import { CircularProgress } from "@mui/material";

import { IPFS_GATEWAY } from "./../utils/ipfsStorage";
import NewsLetter from "./../utils/NewsLetter.json";
import { contractAddress, networkDeployedTo } from "../utils/contracts-config";
import networksMap from "../utils/networksMap.json";

const Post = () => {
  const { id } = useParams();
  const data = useSelector((state) => state.blockchain.value);

  const [loading, setLoading] = useState(false);
  const [tipAmount, setTipAmount] = useState(0);
  const [recentPosts, setRecentPosts] = useState([]);
  const [post, setPost] = useState({
    authorAddress: "",
    authorName: "",
    authorDesc: "",
    authorImg: "",
    title: "",
    content: "",
    coverImg: "",
    readTime: 0,
    createdAt: "",
  });

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  async function getPostDetails() {
    const provider = new ethers.providers.Web3Provider(window.ethereum, "any");
    const chainID = (await provider.getNetwork()).chainId;
    if (networksMap[chainID] === networksMap[networkDeployedTo]) {
      const newsLetter = new ethers.Contract(
        contractAddress,
        NewsLetter.abi,
        provider
      );
      const _post = (await newsLetter.getAllPosts())[Number(id)];

      const authorDetails = await newsLetter.getAuthorDetails(_post[1]);

      const imageUrl = _post[4];
      const profileUrl = authorDetails[3];

      const contentUrl = _post[6];
      let metaData = await axios.get(contentUrl);

      if (authorDetails !== undefined) {
        setPost({
          ...post,
          id: Number(_post[0]),
          authorAddress: _post[1],
          authorName: authorDetails[1],
          authorDesc: authorDetails[2],
          authorImg: profileUrl,
          title: _post[2],
          coverImg: imageUrl,
          readTime: Number(_post[5]),
          content: metaData.data.content,
          createdAt: new Date(Number(_post[7]) * 1000),
        });
      }
    }
  }

  async function getRecentPostsList() {
    const provider = new ethers.providers.Web3Provider(window.ethereum, "any");
    const chainID = (await provider.getNetwork()).chainId;
    if (networksMap[chainID] === networksMap[networkDeployedTo]) {
      const newsLetter = new ethers.Contract(
        contractAddress,
        NewsLetter.abi,
        provider
      );
      const posts = await newsLetter.getAllPosts();

      if (posts !== undefined) {
        const items = await Promise.all(
          posts.map(async (p) => {
            const author = await newsLetter.getAuthorDetails(p[1]);

            const profileUrl = author[3];
            const imageUrl = p[4];

            const item = {
              id: Number(p[0]),
              authorAddress: p[1],
              authorName: author[1],
              authorProfileImg: profileUrl,
              title: p[2],
              overview: p[3],
              coverImage: imageUrl,
              readTime: Number(p[5]),
              createdAt: new Date(Number(p[7]) * 1000),
            };
            return item;
          })
        );
        setRecentPosts(items.reverse());
      }
    }
  }

  async function giveAtip() {
    const provider = new ethers.providers.Web3Provider(window.ethereum, "any");
    const chainID = (await provider.getNetwork()).chainId;
    if (networksMap[chainID] === networksMap[networkDeployedTo]) {
      const signer = provider.getSigner();
      const newsLetter = new ethers.Contract(
        contractAddress,
        NewsLetter.abi,
        signer
      );
      try {
        setLoading(true);

        const tip_tx = await newsLetter.tipPostCreator(Number(id), {
          value: ethers.utils.parseEther(tipAmount.toString(), "ether"),
        });
        await tip_tx.wait();

        setTipAmount(0);
        setShow(false);
        setLoading(false);
      } catch (err) {
        window.alert("An error has occured");
        setLoading(false);
        console.log(err);
      }
    } else {
      window.alert(
        `Please Switch to the ${networksMap[networkDeployedTo]} network`
      );
    }
  }

  useEffect(() => {
    if (window.ethereum !== undefined) {
      getPostDetails();
      getRecentPostsList();
    }
  }, [data.network]);

  return (
    <>
      <div className="container">
        <div className="row">
          <div className="col-md-8 col-md-offset-2 col-xs-12">
            <div className="mainheading">
              <div className="row post-top-meta">
                <div className="col-md-2">
                  <a href={"/author-dashboard/" + post.authorAddress}>
                    <img
                      className="author-thumb"
                      src={post.authorImg}
                      alt="Sal"
                    />
                  </a>
                </div>
                <div className="col-md-10">
                  <a
                    className="link-dark"
                    href={"/author-dashboard/" + post.authorAddress}
                  >
                    {post.authorName}
                  </a>

                  {data.account !== post.authorAddress ? (
                    <>
                      <a onClick={handleShow} className="btn follow">
                        Give a tip
                      </a>
                      <Modal show={show} onHide={handleClose}>
                        <Modal.Header closeButton>
                          <Modal.Title>Tip the post creator</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                          <Form.Group className="mb-3">
                            <Form.Label>Tip Amount:</Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="Enter your tip in ETH"
                              required
                              onChange={(e) => {
                                setTipAmount(e.target.value);
                              }}
                            />
                          </Form.Group>
                        </Modal.Body>
                        <Modal.Footer>
                          <Button variant="secondary" onClick={handleClose}>
                            Close
                          </Button>
                          <Button
                            variant="primary"
                            type="submit"
                            onClick={() => {
                              giveAtip();
                            }}
                          >
                            {loading ? (
                              <CircularProgress color="inherit" />
                            ) : (
                              "Go"
                            )}
                          </Button>
                        </Modal.Footer>
                      </Modal>
                    </>
                  ) : (
                    <a href={"/edit-post/" + post.id} className="btn follow">
                      Edit Post
                    </a>
                  )}
                  <br />
                  <span className="author-description">{post.authorDesc}</span>
                  <br />
                  <span className="post-date">
                    {`  ${post.createdAt.toLocaleString("default", {
                      day: "2-digit",
                    })} ${post.createdAt.toLocaleString("default", {
                      month: "long",
                    })} ${post.createdAt.toLocaleString("default", {
                      year: "numeric",
                    })}  `}
                  </span>
                  <span className="dot"></span>
                  <span className="post-read">{post.readTime} min read</span>
                </div>
              </div>

              <h1 className="posttitle">{post.title}</h1>
            </div>

            <img
              className="featured-image img-fluid"
              src={post.coverImg}
              alt=""
            />

            <div className="article-post" data-color-mode="light">
              <MDEditor.Markdown
                source={post.content}
                style={{ whiteSpace: "pre-wrap" }}
              />
            </div>
          </div>
        </div>
      </div>

      <div className="hideshare"></div>

      <div className="graybg">
        <div className="container">
          <div className="section-title">
            <h2>
              <span>Recent Posts</span>
            </h2>
          </div>
          <div className="row listrecent listrelated">
            {recentPosts.slice(0, 3).map((post, index) => {
              return (
                <div className="col-md-4" key={index}>
                  <div className="card">
                    <a href={"/post/" + post.id}>
                      <img
                        className="img-fluid img-thumb-1"
                        src={post.coverImage}
                        alt=""
                      />
                    </a>
                    <div className="card-block" style={{ textAlign: "left" }}>
                      <h2 className="card-title">
                        <a href={"/post/" + post.id}>{post.title}</a>
                      </h2>
                      <div className="metafooter">
                        <div className="wrapfooter">
                          <span className="meta-footer-thumb">
                            <a href={"/author-dashboard/" + post.authorAddress}>
                              <img
                                className="author-thumb"
                                src={post.authorProfileImg}
                                alt="Sal"
                              />
                            </a>
                          </span>
                          <span className="author-meta">
                            <span className="post-name">
                              <a
                                href={"/author-dashboard/" + post.authorAddress}
                              >
                                {post.authorName}
                              </a>
                            </span>
                            <br />
                            <span className="post-date">
                              {`  ${post.createdAt.toLocaleString("default", {
                                day: "2-digit",
                              })} ${post.createdAt.toLocaleString("default", {
                                month: "long",
                              })} ${post.createdAt.toLocaleString("default", {
                                year: "numeric",
                              })}  `}
                            </span>
                            <span className="dot"></span>
                            <span className="post-read">
                              {post.readTime} min read
                            </span>
                          </span>
                          <span className="post-read-more">
                            <a href={"/post/" + post.id} title="Read Story">
                              <svg
                                className="svgIcon-use"
                                width="25"
                                height="25"
                                viewBox="0 0 25 25"
                              >
                                <path
                                  d="M19 6c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2v14.66h.012c.01.103.045.204.12.285a.5.5 0 0 0 .706.03L12.5 16.85l5.662 4.126a.508.508 0 0 0 .708-.03.5.5 0 0 0 .118-.285H19V6zm-6.838 9.97L7 19.636V6c0-.55.45-1 1-1h9c.55 0 1 .45 1 1v13.637l-5.162-3.668a.49.49 0 0 0-.676 0z"
                                  fillRule="evenodd"
                                ></path>
                              </svg>
                            </a>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
};

export default Post;
